import type { Column } from "@/types/array.types";
import type { Database } from "@/types/database.types";
import { formatDateDisplay } from "@/utils/date";
import { type SortOption } from "../../view-model/viewModel";
import { Icon } from "@/components/icon";

export type ArtType = Database["public"]["Tables"]["art"]["Row"];
type ArtWithImage = ArtType & {
    imageUrl?: string;
    certificateUrl?: string;
  };
export type ArtInsert = Database["public"]["Tables"]["art"]["Insert"];
export type ArtUpdate = Database["public"]["Tables"]["art"]["Update"];

export const columns = [
    {
        key: "document_id", 
        label: "Photo",
        render: (row) => (
            row.imageUrl 
              ? <img src={row.imageUrl} className="table-image" />
              : "-"
          )
    }, 
    {key: "artist", label: "Artiste"}, 
    {key: "description", label: "Description", render: (row) => row.description == null ? "" : row.description}, 
    {
        key: "price", 
        label: "Prix", 
        render: (row) => row.price ? <div className="table-price-column">{new Intl.NumberFormat("it-IT").format(row.price)} €</div> : "",
        validate: (value) => {
        if (value && isNaN(Number(value))) {
        return "Le prix doit être un nombre.";
        }
        return null;
        },
    }, 
    {key: "assurance_location", label: "Assurance"}, 
    {
        key: "creation_date", 
        label: "Création", 
        render: (row) =>
        formatDateDisplay(row.creation_date),
        validate: (value) => {
            return value && isNaN(Date.parse(String(value)))
                ? "La date est invalide."
                : null;
            },
        renderLabel: (row) =>
            row?.creation_date && formatDateDisplay(new Date(row.creation_date))
        }, 
    {key: "comment", label: "Commentaire", render: (row) => row.comment == null ? "" : row.comment},
    {
            key: "certificate_id", 
            label: "Certificat",
            render: (row) => (
                row.certificateUrl 
                  ? <a href={row.certificateUrl} className="table-pdf" target="_blank">
                        <Icon name="document"/>
                        <p>PDF</p>
                    </a>
                  : "-"
              )
        }, 
    {key: "id", label: "id"}
] as Column<ArtWithImage>[];

export const filters = [
        {key: "artist", label: "Artiste"},  
        {key: "assurance_location", label: "Assurance"}
    ] as Column<ArtType>[];

export const sortOptions = [
    {
        key: "artist",
        label: "Par artistes",
        by: "croissant"
    },
    {
        key: "price",
        label: "Prix croissant",
        by: "croissant"
    },
    {
        key: "price",
        label: "Prix décroissant",
        by: "décroissant"
    },
    {
        key: "created_at",
        label: "Plus récent",
        by: "décroissant"
    },
    {
        key: "created_at",
        label: "Plus ancien",
        by: "croissant"
    },
] as SortOption[];

export const columnsExport = [
    {
        label: "Photo", 
        key: "document_id",
        render: (row) => row.imageUrl ?? ""
    },
    {
        label: "Artiste", 
        key: "artist",
        render: (row) => row.artist == null ? "" : row.artist
    },
    {
        label: "Description",  
        key: "description",
        render: (row) => row.description == null ? "" : row.description
    },
    {
        label: "Prix", 
        key: "price",
        render: (row) => row.price ? `${new Intl.NumberFormat("fr-FR").format(row.price).replace(/\u202F/g, " ")} €` : ""
    },
    {
        label: "Assurance", 
        key: "assurance_location",
        render: (row) => row.assurance_location == null ? "" : row.assurance_location
    },
    {
        label: "Création",
        key: "creation_date",
        render: (row) => {
            return row.creation_date ? new Intl.DateTimeFormat("fr-FR", { dateStyle: "short" }).format(
            new Date(row.creation_date) 
          ) : ""
    }},
    {
        label: "Commentaire",
        key: "comment",
        render: (row) => row.comment == null ? "" : row.comment
    }
] as Column<ArtWithImage>[];

